import React from 'react';
import Button from './Button';

const Section1 = ({ link }) => {
    return (
        <div className="section-container">
            <div className="text-column">
                <h1 className='title' style={{ 'maxWidth': '500px' }}>Crie <span className='blue'>Dashboards</span> e <span className='blue'>Relatórios interativos</span> em poucos minutos</h1>

                <h2 className='subtitle text'>Aprenda a transformar seus dados em <span className='blue'>visualizações impactantes</span> e se destaque no mercado de trabalho. Adquira habilidades em <span className='blue'>análise de dados</span> e apresentação de relatórios de forma <span className='blue'>descomplicada</span> com Looker Studio.</h2>

                <Button href={link} />

            </div>
            <div className="image-column">
                <img
                    src="graphic.jpg"
                    alt="Produtor"
                />
            </div>
        </div>
    );
};

export default Section1;
